import { AttributeType } from '@containers/ProductListing/model';

import { useProductDetailContext } from '../../../ProductDetailContext';

import { IConditionalVoucherDiscount } from './ConditionalVoucherDiscount';
import { IVoucherDiscount } from './VoucherDiscount';

export const useResolvedVoucherDiscount = ({
  attributes,
}: {
  attributes?: AttributeType;
} = {}): IVoucherDiscount | IConditionalVoucherDiscount | null => {
  const productCtx = useProductDetailContext(false);
  return resolveVoucherDiscount(
    attributes ? { attributes } : productCtx.currentVariant
  );
};

export const resolveVoucherDiscount = ({
  attributes: _attributes,
}: {
  attributes?: AttributeType;
} = {}): IVoucherDiscount | IConditionalVoucherDiscount | null => {
  const attributes = _attributes ?? {};

  if (attributes.VoucherDiscount) {
    return attributes.VoucherDiscount;
  }

  const conditionalVoucherDiscount = attributes.ConditionalVoucherDiscount as
    | IConditionalVoucherDiscount
    | undefined;

  if (conditionalVoucherDiscount?.discountConditions.length) {
    return conditionalVoucherDiscount;
  }

  return null;
};
